module.exports = __webpack_public_path__ + "static/process-detail-3b.e97299b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-3b.png
// module id = 1492
// module chunks = 214286880276331